import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { GlobalMessageService, GlobalMessageType } from '@spartacus/core';
import moment from 'moment';
import { Subject, Subscription } from 'rxjs';
import { WarrantyInfoService } from 'src/app/services/feature/warrantyInfo/warranty-info.service';

@Component({
  selector: 'app-warranty-eligible-check',
  templateUrl: './warranty-eligible-check.component.html',
  styleUrls: ['./warranty-eligible-check.component.scss'],
  standalone: false
})
export class WarrantyEligibleCheckComponent {
  private unsubscribe$ = new Subject<void>();
  @Input() warranty: any;
  isMobile: boolean = false;
  isSubmitted = false;
  bsDate: Date = new Date();
  dateFormat = '';
  sub = new Subscription();
  @Output() selectedEligibilityResult = new EventEmitter<any>();
  productNotFound = '';
  constructor(
    private breakpointObserver: BreakpointObserver,
    private warrantyInfoService: WarrantyInfoService,
    private cdr: ChangeDetectorRef,
    private globalMsgService: GlobalMessageService,
    protected router: Router
  ) {
    this.sub.add(
      this.breakpointObserver.observe([Breakpoints.XSmall, Breakpoints.Small]).subscribe((result) => {
        this.isMobile = result.matches;
      })
    );

    //get warranty info
    this.sub.add(this.warrantyInfoService.getApi().subscribe((res: any) => {
      this.dateFormat = res.dateFormat;
    }))
  }
  warrantyEligibilityCheckForm = new FormGroup({
    partNumber: new FormControl(null, [Validators.required]),
    mileageInService: new FormControl(null, [Validators.required]),
    typeOfOperation: new FormControl(null, [Validators.required]),
    inServiceString: new FormControl(null, [Validators.required]),
    removedFromServiceString: new FormControl(null, [Validators.required]),
    vehicleId: new FormControl(null),
  });
  get warrantyEligibilityCheckControls() {
    return this.warrantyEligibilityCheckForm.controls;
  }
  onSubmit() {
    this.isSubmitted = true;
    if (this.warrantyEligibilityCheckForm.invalid) {
      const key = 'common.form_global_error';
      this.globalMsgService.add({ key: key }, GlobalMessageType.MSG_TYPE_ERROR);
      this.warrantyEligibilityCheckForm.markAllAsTouched();
    } else {

      const payload = {
        vinNumber: this.warrantyEligibilityCheckControls.vehicleId.value,
        typeOfOperation: this.warrantyEligibilityCheckControls.typeOfOperation.value,
        partInfoDataList: [
          {
            partNumber: this.warrantyEligibilityCheckControls.partNumber.value,
            inServiceString: this.warrantyEligibilityCheckControls.inServiceString.value,
            removedFromServiceString: this.warrantyEligibilityCheckControls.removedFromServiceString.value,
            mileageInService: this.warrantyEligibilityCheckControls.mileageInService.value,
          },
        ],
      };
      if (payload.partInfoDataList.length > 0) {
        const partInService = moment(payload.partInfoDataList[0].inServiceString).format(this.dateFormat?.toUpperCase())
        payload.partInfoDataList[0].inServiceString = partInService;
        const remFromService = moment(payload.partInfoDataList[0].removedFromServiceString).format(this.dateFormat?.toUpperCase());
        payload.partInfoDataList[0].removedFromServiceString = remFromService
      }
      this.sub.add(
        this.warrantyInfoService.postApi(payload).subscribe((warranty: any) => {
          if (warranty?.kbStatusMessageWSDTO?.status === 'error') {
            this.productNotFound = warranty?.kbStatusMessageWSDTO?.message;
            this.cdr.detectChanges();
            return;
          }
          const response = warranty?.kbStatusMessageWSDTO?.eligibilityResult;
          this.cdr.detectChanges();
          this.selectedEligibilityResult.emit(response);
        })
      );
    }
  }
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    this.isSubmitted = false;
    this.sub.unsubscribe();
  }
}
